import { useState } from 'react'

import { reduce } from 'lodash-es'
import { DataItem } from 'scrivito'

interface References {
  [key: string]: DataItem
}

export interface DataItemReferenceAdd {
  (dataItems: DataItem[]): void
}

export interface DataItemReferenceGet {
  (id: string): DataItem | undefined
}

export interface DataItemReferenceRemove {
  (ids: string[]): void
}

export interface DataItemReferenceIds {
  (): string[]
}

export interface DataItemReferences {
  add: DataItemReferenceAdd
  get: DataItemReferenceGet
  remove: DataItemReferenceRemove
  ids: DataItemReferenceIds
}

export const useDataItemReferenceHandler: () => DataItemReferences = () => {
  const [references, setReferences] = useState<References>({})

  const add = (dataItems: DataItem[]) => {
    setReferences((references) => {
      return reduce(
        dataItems,
        (references, dataItem) => {
          return { ...references, [dataItem.id().toUpperCase()]: dataItem }
        },
        references,
      )
    })
  }

  const get = (id: string): DataItem | undefined => {
    return references[id.toUpperCase()]
  }

  const remove = (ids: string[]) => {
    setReferences((references) => {
      return reduce(
        ids,
        (references, id) => {
          const { [id]: _removed, ...rest } = references
          return rest
        },
        references,
      )
    })
  }

  const ids: () => string[] = () => {
    return Object.keys(references)
  }

  return {
    add,
    get,
    remove,
    ids,
  }
}
